import React from 'react';
import { Tag, Tooltip } from 'antd';
import { MassiveStatus } from 'services/MassiveService';
import { statusView } from './status';

interface Props {
  status: MassiveStatus;
  missingLabels?: number;
  reason?: string;
}

const MassiveStatusTag = ({ status, missingLabels = 0, reason }: Props) => {
  const { label, color } = statusView(status);
  const tag = reason ? (
    <Tooltip title={reason}>
      <Tag color={color}>{label}</Tag>
    </Tooltip>
  ) : (
    <Tag color={color}>{label}</Tag>
  );

  if (missingLabels > 0) {
    return (
      <Tooltip
        title={`${missingLabels} paquetes quedaron sin etiqueta: el PDF está incompleto.`}
      >
        <span>
          {tag}
          <Tag color="warning">sin etiqueta: {missingLabels}</Tag>
        </span>
      </Tooltip>
    );
  }
  return tag;
};

export default MassiveStatusTag;
